import type { KeyboardAction } from '../user-interfaces/hooks/use-keyboard-shortcuts';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { StepForwardCircleIcon } from '../../icons/step-forward-circle';

import styles from './step-indicator.module.css';

type Props = {
  lastKeyboardAction?: KeyboardAction;
};

export function StepForwardIndicator({ lastKeyboardAction }: Props) {
  const { t } = useTranslation();
  return (
    <div
      className={classNames(styles.stepIndicatorWrapper, styles.forwardIndicator)}
      data-testid="step-indicator-wrapper"
    >
      <div className={styles.stepIndicator}>
        <StepForwardCircleIcon />
        <div className={styles.stepIndicatorLabel} data-testid="step-indicator-label">
          {lastKeyboardAction === 'ShortTimeIncrease'
            ? t('ui.short-step.overlay.label')
            : t('ui.long-step.overlay.label')}
        </div>
      </div>
    </div>
  );
}
